import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin(() => {
  // Vue carousel functionality replaced by vue3-carousel
});
